/** Explicit outcomes keep a cancelled SPA transition distinct from a native link. */
export type NavigationOutcome = "accepted" | "blocked" | "native";
export const locationChangeEvent = "teddify-location-change";

// Existing editors own their draft/busy policy. Keep this event contract shared
// by links, history traversal and sign-out without duplicating those policies.
export function requestPageLeave(): boolean {
  return window.dispatchEvent(new Event("planner-settings-leave", { cancelable: true }));
}
